import React from 'react';
import Icons from './Icons';

const FeaturesSection = () => {
  const features = [
    {
      icon: <Icons.Building />,
      title: 'Perfiles verificados',
      description: 'Los perfiles publicados en GesOps son validados antes de mostrarse en el directorio. Cada profesional o empresa autoriza el uso de su información y mantiene independencia total en la prestación de sus servicios.'
    },
    {
      icon: <Icons.Globe />,
      title: 'Cobertura nacional',
      description: 'Conectamos usuarios con servicios confiables en múltiples estados de Estados Unidos y Puerto Rico, facilitando la búsqueda por ubicación y categoría.'
    },
    {
      icon: <Icons.Award />,
      title: 'Transparencia y confianza',
      description: 'Nuestro directorio está diseñado para facilitar conexiones claras y directas.\n\nDisclaimer: GesOps no garantiza resultados ni un número específico de clientes. El desempeño y la experiencia pueden variar según cada profesional o empresa.'
    },
    {
      icon: <Icons.MessageSquare />,
      title: 'Contacto directo',
      description: 'Los usuarios pueden contactar directamente al profesional o empresa sin intermediarios, sin comisiones y sin complicaciones. GesOps no participa en pagos ni honorarios entre las partes.'
    }
  ];

  return (
    <section className="features-section" id="servicios">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">¿Por qué elegirnos?</h2>
          <p className="section-description">
            Ofrecemos una forma simple y confiable de encontrar servicios verificados en un solo lugar
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => {
            const parts = feature.description.split('\n\n');
            const mainText = parts[0];
            const extraText = parts[1];

            return (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{mainText}</p>
                {extraText && index === 2 && (
                  <p className="feature-description">
                    <strong>Disclaimer:</strong> {extraText.replace('Disclaimer: ', '')}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
